import { FC } from "react";

import { Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import PriorityIndicator from "components/priority/PriorityIndicator";
import { TICKET_PRIORITY_LABEL_MAP } from "constants/tickets/priorities";
import { TicketPriority } from "interfaces/entities/ticket";

interface IProps {
  priority: TicketPriority;
}

export const PriorityPickerListItem: FC<IProps> = ({ priority }) => (
  <Flex gap="8px" alignItems="center">
    <PriorityIndicator priority={priority} />
    <Text>{TICKET_PRIORITY_LABEL_MAP[priority]}</Text>
  </Flex>
);
